let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cpX7N")).then(() => parcelRequire('2yAmG'));